/* Wholesale application: validation, progress meter, dependent city list, Formspree submit with recap. */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var root = document.querySelector('[data-wholesale]');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var d = root.dataset;
  /* Country and city list copied from the live wholesale form. */
  var CITIES = {"Türkiye": ["İstanbul", "Ankara", "İzmir", "Bursa", "Antalya", "Adana", "Gaziantep", "Mersin", "Konya", "Kayseri"], "United Arab Emirates": ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Ras Al Khaimah", "Fujairah", "Umm Al Quwain", "Al Ain"], "Saudi Arabia": ["Riyadh", "Jeddah", "Dammam", "Khobar", "Mecca", "Medina"], "Qatar": ["Doha", "Al Rayyan", "Al Wakrah"], "Kuwait": ["Kuwait City", "Hawalli", "Salmiya"], "Bahrain": ["Manama", "Riffa", "Muharraq"], "Oman": ["Muscat", "Salalah", "Sohar"], "Jordan": ["Amman", "Irbid", "Aqaba"], "Lebanon": ["Beirut", "Tripoli", "Sidon"], "Egypt": ["Cairo", "Alexandria", "Giza", "Mansoura"], "Iraq": ["Baghdad", "Erbil", "Basra", "Sulaymaniyah"], "Morocco": ["Casablanca", "Rabat", "Marrakech", "Tangier"], "Algeria": ["Algiers", "Oran", "Constantine"], "Tunisia": ["Tunis", "Sfax", "Sousse"], "Libya": ["Tripoli", "Benghazi"], "United Kingdom": ["London", "Manchester", "Birmingham", "Glasgow"], "France": ["Paris", "Lyon", "Marseille", "Nice"], "Germany": ["Berlin", "Hamburg", "Munich", "Frankfurt"], "Italy": ["Milan", "Rome", "Florence", "Naples"], "Spain": ["Madrid", "Barcelona", "Valencia", "Seville"], "Netherlands": ["Amsterdam", "Rotterdam", "The Hague"], "Belgium": ["Brussels", "Antwerp", "Ghent"], "Switzerland": ["Zurich", "Geneva", "Basel"], "Austria": ["Vienna", "Salzburg", "Graz"], "Sweden": ["Stockholm", "Gothenburg", "Malmö"], "Norway": ["Oslo", "Bergen", "Trondheim"], "Denmark": ["Copenhagen", "Aarhus", "Odense"], "Greece": ["Athens", "Thessaloniki", "Patras"], "Romania": ["Bucharest", "Cluj-Napoca", "Timișoara"], "Bulgaria": ["Sofia", "Plovdiv", "Varna"], "Azerbaijan": ["Baku", "Ganja", "Sumqayit"], "Georgia": ["Tbilisi", "Batumi", "Kutaisi"], "Kazakhstan": ["Almaty", "Astana", "Shymkent"], "United States": ["California", "New York", "Texas", "Florida", "Illinois"], "Canada": ["Toronto", "Vancouver", "Montreal", "Calgary"], "Australia": ["Sydney", "Melbourne", "Brisbane", "Perth"], "New Zealand": ["Auckland", "Wellington", "Christchurch"], "India": ["Mumbai", "Delhi", "Bengaluru", "Hyderabad"], "Pakistan": ["Karachi", "Lahore", "Islamabad"], "Japan": ["Tokyo", "Osaka", "Kyoto"], "South Korea": ["Seoul", "Busan", "Incheon"], "China": ["Shanghai", "Beijing", "Guangzhou", "Shenzhen"], "Singapore": ["Singapore"], "Malaysia": ["Kuala Lumpur", "Penang", "Johor Bahru"], "Indonesia": ["Jakarta", "Bali / Denpasar", "Surabaya"]};
  var form = $('[data-wform]'), country = $('[data-country]'), city = $('[data-city]'), cityOther = $('[data-city-other]');
  var meter = $('[data-meter]'), meterText = $('[data-meter-text]'), summary = $('[data-summary]');
  var tried = false;
  var tick = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9B4D67" stroke-width="2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  Object.keys(CITIES).forEach(function (c) { var o = document.createElement('option'); o.value = c; o.textContent = c; country.appendChild(o); });
  var oc = document.createElement('option'); oc.value = '__other__'; oc.textContent = d.strOther; country.appendChild(oc);

  function fillCities() {
    var c = country.value;
    city.innerHTML = '';
    var ph = document.createElement('option'); ph.value = ''; ph.textContent = c ? d.strSelectCity : d.strCityFirst; city.appendChild(ph);
    (CITIES[c] || []).forEach(function (n) { var o = document.createElement('option'); o.value = n; o.textContent = n; city.appendChild(o); });
    if (c) { var o2 = document.createElement('option'); o2.value = '__other__'; o2.textContent = d.strOther; city.appendChild(o2); }
    city.disabled = !c;
    if (c === '__other__') city.value = '__other__';
    toggleOther();
  }
  function toggleOther() {
    var show = city.value === '__other__';
    cityOther.hidden = !show;
    if (!show) cityOther.value = '';
  }
  country.addEventListener('change', function () { fillCities(); update(); });
  city.addEventListener('change', function () { toggleOther(); update(); });

  $$('[data-seg]').forEach(function (seg) {
    var hidden = form.querySelector('input[name="' + seg.dataset.seg + '"]');
    $$('button', seg).forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        $$('button', seg).forEach(function (x) { x.setAttribute('aria-pressed', x === b && on ? 'true' : 'false'); });
        hidden.value = on ? b.dataset.v : '';
        update();
      });
    });
  });
  $$('[data-cats] .chip').forEach(function (c) {
    c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); update(); });
  });

  function valid(el) {
    var v = (el.value || '').trim(), k = el.dataset.req;
    if (k === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    if (k === 'phone') return (v.match(/\d/g) || []).length >= 7;
    if (k === 'city') return !!v && (v !== '__other__' || !!cityOther.value.trim());
    return !!v;
  }
  function fieldOf(el) { return el.closest('.fld'); }
  function mark(el, ok) {
    var f = fieldOf(el); if (!f) return;
    var err = f.querySelector('.err'); if (err) err.hidden = ok;
    var seg = f.querySelector('.seg'); if (seg) seg.classList.toggle('bad', !ok);
    if (el.type !== 'hidden') el.setAttribute('aria-invalid', ok ? 'false' : 'true');
  }
  function update() {
    var reqs = $$('[data-req]');
    var done = reqs.filter(valid).length, total = reqs.length;
    meter.querySelector('i').style.width = (done / total * 100) + '%';
    meter.setAttribute('aria-valuenow', done);
    meter.setAttribute('aria-valuemax', total);
    meterText.textContent = done + ' / ' + total;
    $$('[data-step]').forEach(function (fs) {
      var step = fs.dataset.step, r = $$('[data-req]', fs), tag = $('[data-toc="' + step + '"]');
      if (!tag) return;
      var ok;
      if (!r.length) {
        ok = $$('input:not([type=hidden]), textarea', fs).some(function (x) { return x.value.trim(); }) || $$('[aria-pressed="true"]', fs).length > 0;
        tag.className = ok ? 'done' : '';
        tag.innerHTML = ok ? tick + d.strComplete : d.strOptional;
        return;
      }
      ok = r.every(valid);
      tag.className = ok ? 'done' : '';
      tag.innerHTML = ok ? tick + d.strComplete : d.strTodo;
    });
    if (tried) reqs.forEach(function (el) { mark(el, valid(el)); });
    return total - done;
  }
  form.addEventListener('input', update);
  form.addEventListener('focusout', function (e) { var el = e.target; if (el.dataset && el.dataset.req && el.value) mark(el, valid(el)); });

  function setBtn(txt, busy) {
    var b = $('[data-submit]');
    $$('[data-submit-label]').forEach(function (s) { s.textContent = txt; });
    if (busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    b.disabled = !!busy;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    tried = true;
    var missing = update();
    if (missing > 0) {
      summary.textContent = missing === 1 ? d.strSummary1 : d.strSummary.replace('__N__', missing);
      summary.hidden = false;
      summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = $$('[data-req]').filter(function (el) { return !valid(el); })[0];
      if (first) {
        var target = first.type === 'hidden' ? fieldOf(first).querySelector('button') : first;
        setTimeout(function () { if (target) target.focus({ preventScroll: true }); }, 400);
      }
      return;
    }
    summary.hidden = true;
    var fd = new FormData(form);
    if (fd.get('city_state') === '__other__') fd.set('city_state', fd.get('city_state_other'));
    if (fd.get('country') === '__other__') fd.set('country', d.strOther);
    var cats = $$('[data-cats] .chip[aria-pressed="true"]').map(function (c) { return c.dataset.v; });
    cats.forEach(function (c) { fd.append('categories', c); });
    setBtn(d.strSending, true);
    fetch(form.action, { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('send'); return r.json(); })
      .then(function () {
        var done = $('[data-done]'), recap = $('[data-recap]');
        $('[data-done-title]').textContent = d.strDone.replace('__NAME__', fd.get('first_name'));
        var rows = [
          [recap.dataset.kName, fd.get('first_name') + ' ' + fd.get('last_name')],
          [recap.dataset.kBiz, fd.get('business_name')],
          [recap.dataset.kLoc, [fd.get('city_state'), fd.get('country')].filter(Boolean).join(', ')],
          [recap.dataset.kType, fd.get('business_type')],
          [recap.dataset.kCats, cats.length ? cats.join(', ') : d.strNone],
          [recap.dataset.kEmail, fd.get('email')]
        ];
        recap.innerHTML = '';
        rows.forEach(function (r) {
          var div = document.createElement('div'), sp = document.createElement('span');
          sp.textContent = r[0];
          div.appendChild(sp);
          div.appendChild(document.createTextNode(r[1] || d.strNone));
          recap.appendChild(div);
        });
        form.hidden = true;
        done.hidden = false;
        done.focus({ preventScroll: true });
        done.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function () {
        summary.textContent = d.strError;
        summary.hidden = false;
        setBtn(d.strSubmit, false);
      });
  });
  fillCities();
  update();
});
